import React, { useState, useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { verifyToken } from "../utils/auth";
import { devError } from "../utils/logger";

const ProtectedRoute = ({ allowedRoles = [] }) => {
  const [authStatus, setAuthStatus] = useState({
    loading: true,
    valid: false,
    role: null,
  });

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const user_data = await verifyToken();

        if (user_data.valid) {
          setAuthStatus({
            loading: false,
            valid: true,
            role: user_data.user.user.role,
          });
        } else {
          setAuthStatus({ loading: false, valid: false, role: null });
        }
      } catch (error) {
        devError("Error verifying token:", error);
        setAuthStatus({ loading: false, valid: false, role: null });
      }
    };

    checkAuth();
  }, []);

  if (authStatus.loading) return React.createElement("div", null, "Loading...");

  if (!authStatus.valid || !allowedRoles.includes(authStatus.role)) {
    return React.createElement(Navigate, { to: "/" });
  }

  return React.createElement(Outlet);
};

export { ProtectedRoute };
